import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';
import { Allergens } from 'src/interfaces/enums.model';

@Pipe({
    name: 'allergenTranslate',
    pure: true,
    standalone: false
})
export class AllergenTranslatePipe implements PipeTransform {

  constructor(private localization: LocalizationService) {}

  transform(allergen: Allergens): string {
    return this.localization.getAllergenTranslation(allergen);
  }

}
